module.exports = __webpack_public_path__ + "img/double_bubble_layout_2.25666d75.svg";